import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tag, Tooltip } from 'antd';
import { TrainingSessionStatus } from '../../types';

const getStatusColor = (status?: TrainingSessionStatus) => {
    switch (status) {
        case 'Draft':
            return 'gold';
        case 'Running':
            return 'processing';
        case 'Succeeded':
            return 'green';
        case 'Failed':
            return 'error';
        case 'Canceled':
            return 'magenta';
        default:
            return 'default';
    }
};

interface Props {
    status?: TrainingSessionStatus;
    tooltipText?: string | null;
    noStatusLabel?: string;
}

const TrainingSessionStatusTag: React.FC<Props> = ({ status, tooltipText, noStatusLabel = 'No Status' }) => {
    return (
        <Tooltip title={tooltipText}>
            <Tag color={getStatusColor(status)}>{status ?? noStatusLabel}</Tag>
        </Tooltip>
    );
};

export default observer(TrainingSessionStatusTag);
